import { render, staticRenderFns } from "./payouts.vue?vue&type=template&id=0620aef4&scoped=true"
import script from "./payouts.vue?vue&type=script&lang=js"
export * from "./payouts.vue?vue&type=script&lang=js"
import style0 from "./payouts.vue?vue&type=style&index=0&id=0620aef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0620aef4",
  null
  
)

export default component.exports